import type { OrganizationMembershipLevel } from '~/types/organization';
import type { IdentityUserData, UserData } from '~/types/user';

export enum ProLevels {
  PRO = 1,
  PRO_50 = 2,
  PRO_100 = 3,
  PRO_200 = 4,
  PRO_300 = 5,
  PRO_400 = 6,
  PRO_500 = 7,
  PRO_600 = 8,
  PRO_700 = 9,
  PRO_800 = 10,
  PRO_900 = 11,
  PRO_1000 = 12,
  PRO_1500 = 13,
  PRO_2000 = 14,
}

export type EffectiveTier =
  | {
      plan: 'personal';
      isPaid: false;
      level: 0;
    }
  | {
      plan: 'pro';
      isPaid: true;
      level: ProLevels;
    }
  | {
      plan: 'teams';
      isPaid: boolean;
      level: OrganizationMembershipLevel;
    };

export function effectiveTier(user: UserData | Pick<IdentityUserData, 'membership'>): EffectiveTier {
  if ('activeOrganizationId' in user && user.activeOrganizationId) {
    const organization = user.organizations?.find((org) => org.id === user.activeOrganizationId) ?? null;

    if (!organization) {
      throw new Error('Effective tier could not be found');
    }

    const level = clamp(organization.billing?.tier ?? 0, 14);

    return {
      plan: 'teams',
      isPaid: !!organization.billing?.paid,
      level,
    };
  }

  if (!user || !user.membership || user.membership.tier === 0) {
    return {
      plan: 'personal',
      isPaid: false,
      level: 0,
    };
  }

  return {
    plan: 'pro',
    isPaid: true,
    level: clamp(user.membership.tier, 14),
  };
}

function clamp<T extends number>(value: T, max: NoInfer<T>): T {
  return Math.min(value, max) as T;
}
